<div class="question">
  <div class="title">{{ question.title }}</div>
  @if (question.type_id === QuestionType.OPEN) {
    <div>
      <app-countable-textarea #textarea (change)="onTextChange($event)" [control]="form.controls['textarea']" />
    </div>
  } @else {
    @for (choice of question.questionChoices; track choice) {
      <div class="choice">
        @if (question.type_id === QuestionType.SINGLE_CHOICE) {
          <app-input #input
            type="radio"
            [name]="'question_' + question.id"
            [control]="form.controls['radio']"
            [value]="String(choice.position)"
            (change)="onRadioChange($event)"
            [label]="choice.title">
          </app-input>
        }
        @if (question.type_id === QuestionType.MULTIPLE_CHOICE) {
          <app-input #input
            type="checkbox"
            [name]="'question_' + question.id + '_' + choice.position"
            [control]="form.controls['checkbox']"
            [value]="String(choice.position)"
            (change)="onCheckboxChange($event)"
            [label]="choice.title">
          </app-input>
        }
      </div>
    }
  }
</div>
